import { EnrolledPanel } from "@/components/security/enrolled-panel";
import { BackupCodesStep, EnrollmentFlow } from "@/components/security/enrollment-flow";
import { SettingsLayout } from "@/components/settings-layout";
import { useSession } from "@/lib/auth-client";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/_app/settings/security")({
	component: SecurityPage,
});

function SecurityPage() {
	const { data: session, isPending } = useSession();
	const user = session?.user;
	const isEnrolled = user?.twoFactorEnabled === true;

	// Holds the backup codes surfaced by `authClient.twoFactor.enable` after
	// a successful TOTP verify. Lifted to the parent so the display survives
	// the session refetch that flips `twoFactorEnabled` to true and would
	// otherwise unmount EnrollmentFlow mid-transition. Cleared when the user
	// acknowledges via BackupCodesStep's "Done" button. See W-1 (2026-04).
	const [justEnrolledCodes, setJustEnrolledCodes] = useState<string[] | null>(null);

	return (
		<SettingsLayout>
			<div>
				<h2 className="text-lg font-semibold text-[#1e1e20]">Security</h2>
				<p className="mt-1 text-sm text-[#6b7280]">
					Two-factor authentication adds a second step when you sign in.
				</p>
			</div>

			{isPending ? (
				<div className="rounded-lg border border-[#e5e7eb] bg-white p-6">
					<div className="h-6 w-48 animate-pulse rounded bg-[#f3f4f6]" />
				</div>
			) : justEnrolledCodes ? (
				<div className="rounded-lg border border-[#e5e7eb] bg-white p-6">
					<BackupCodesStep codes={justEnrolledCodes} onDone={() => setJustEnrolledCodes(null)} />
				</div>
			) : isEnrolled ? (
				<EnrolledPanel />
			) : (
				<EnrollmentFlow onEnrolled={setJustEnrolledCodes} />
			)}
		</SettingsLayout>
	);
}
